import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { ReactNode } from "react";

import { useIsMemberAreaAppShellEnabled } from "@/react/hooks/useIsMemberAreaAppShellEnabled";

export interface SidebarV2WrapperProps {
  children: ReactNode;
}

export const SidebarV2Wrapper = ({ children }: SidebarV2WrapperProps) => {
  const isMemberAreaAppShellEnabled = useIsMemberAreaAppShellEnabled();

  return (
    <div
      className={classNames(
        "bg-c-sidebar flex h-full max-h-full flex-col",
        isMemberAreaAppShellEnabled ? "w-full" : "w-sidebar-v3 fixed",
      )}
    >
      {children}
    </div>
  );
};
